import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import PublicLayout from "./components/PublicLayout";

// Public Pages
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import NewsletterUnsubscribePage from "./pages/NewsletterUnsubscribePage";
import FAQPage from "./pages/FAQPage";
import LoginPage from "./pages/LoginPage";
import PrivacyPage from "./pages/PrivacyPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SecurityPage from "./pages/SecurityPage";
import TermsPage from "./pages/TermsPage";

// User Pages
import UserDashboard from "./pages/UserDashboard";
import KYC from "./pages/KYC";
import Profile from "./pages/ProfilePage";
import Transactions from "./pages/Transactions";
import Fund from "./pages/Fund";
// import Withdraw from "./pages/Withdraw";
import PayBills from "./pages/PayBills";
import SendMoney from "./pages/SendMoney";
import Wallet from "./pages/Wallet";
// import CryptoPage from "./pages/CryptoPage";
import ChatPage from "./pages/ChatPage";
import MekHubPage from "./pages/MekHubPage";
import PaymentCallback from "./pages/Payments/Callback";

// Admin Pages
import AdminDashboard from "./pages/AdminDashboard";
import AdminKYC from "./pages/AdminKYCPage";
import AdminUsersPage from "./pages/AdminUserPage";
import AdminTransactionsPage from "./pages/AdminTransactionsPage";
import AdminNotificationsPage from "./pages/AdminNotificationsPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import AdminTransfersPage from "./pages/AdminTransfersPage";
// import AdminCryptoApprovalsPage from "./pages/AdminCryptoApprovalsPage";
import AdminWebhooksPage from "./pages/AdminWebhooksPage";
import AdminContactMessagesPage from "./pages/AdminContactMessagesPage";
import AdminNewsletterPage from "./pages/AdminNewsletterPage";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* 🌍 Public pages (no Layout) */}
        <Route path="/" element={<PublicLayout><LandingPage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
        <Route path="/newsletter/unsubscribe" element={<PublicLayout><NewsletterUnsubscribePage /></PublicLayout>} />
        <Route path="/faqs" element={<PublicLayout><FAQPage /></PublicLayout>} />
        <Route path="/security" element={<PublicLayout><SecurityPage /></PublicLayout>} />
        <Route path="/privacy" element={<PublicLayout><PrivacyPage /></PublicLayout>} />
        <Route path="/terms" element={<PublicLayout><TermsPage /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><LoginPage /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><RegisterPage /></PublicLayout>} />
        <Route path="/forgot-password" element={<PublicLayout><ForgotPassword /></PublicLayout>} />
        <Route path="/reset-password/:token" element={<PublicLayout><ResetPassword /></PublicLayout>} />

        {/* 👤 User pages (inside Layout + protected) */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout>
                <UserDashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/kyc"
          element={
            <PrivateRoute>
              <Layout>
                <KYC />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Layout>
                <Profile />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/transactions"
          element={
            <PrivateRoute>
              <Layout>
                <Transactions />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/fund"
          element={
            <PrivateRoute>
              <Layout>
                <Fund />
              </Layout>
            </PrivateRoute>
          }
        />
        {/*
        <Route
          path="/withdraw"
          element={
            <PrivateRoute>
              <Layout>
                <Withdraw />
              </Layout>
            </PrivateRoute>
          }
        />
        */}
        <Route
          path="/pay-bills"
          element={
            <PrivateRoute>
              <Layout>
                <PayBills />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/send-money"
          element={
            <PrivateRoute>
              <Layout>
                <SendMoney />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/wallet"
          element={
            <PrivateRoute>
              <Layout>
                <Wallet />
              </Layout>
            </PrivateRoute>
          }
        />
        {/*
        <Route
          path="/crypto"
          element={<PrivateRoute><Layout><CryptoPage /></Layout></PrivateRoute>}
        />
        */}
        <Route
          path="/messages"
          element={<PrivateRoute><Layout><ChatPage /></Layout></PrivateRoute>}
        />
        <Route
          path="/mekhub"
          element={<PrivateRoute><Layout><MekHubPage /></Layout></PrivateRoute>}
        />
        <Route
          path="/payments/callback"
          element={<PaymentCallback />}
        />

        {/* 🛠️ Admin pages (inside Layout + protected) */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <Layout>
                <AdminDashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/kyc"
          element={
            <PrivateRoute>
              <Layout>
                <AdminKYC />
              </Layout>
            </PrivateRoute>
          }
        />  
        <Route
          path="/admin/users"
          element={
            <PrivateRoute>
              <Layout>
                <AdminUsersPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/transactions"
          element={
            <PrivateRoute>
              <Layout>
                <AdminTransactionsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/notifications"
          element={
            <PrivateRoute>
              <Layout>
                <AdminNotificationsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/contact-messages"
          element={
            <PrivateRoute>
              <Layout>
                <AdminContactMessagesPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/newsletter"
          element={
            <PrivateRoute>
              <Layout>
                <AdminNewsletterPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/webhooks"
          element={
            <PrivateRoute>
              <Layout>
                <AdminWebhooksPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <PrivateRoute>
              <Layout>
                <AdminSettingsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/transfers"
          element={
            <PrivateRoute>
              <Layout>
                <AdminTransfersPage />
              </Layout>
            </PrivateRoute>
          }
        />
        {/*
        <Route
          path="/admin/crypto-approvals"
          element={
            <PrivateRoute>
              <Layout>
                <AdminCryptoApprovalsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        */}

        {/* 404 Page */}
        <Route
          path="*"
          element={
            <div className="text-center py-20 text-2xl">
              404 | Page Not Found
            </div>
          }
        />
      </Routes>
    </Router>
  );
}
